// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3yl_A","gfeWrapper":"CalendarEvent_gfeWrapper__2GwbG"};